import { type Trello } from "./types/trello"
import { CAPABILITY_PROPS, PUP_DISPLAY_NAME } from "./config"
import { getOnEnable } from "./on-enable/capability"
import { getShowAuthorization } from "./show-authorization/capability"
import { getAuthorizationStatus } from "./authorization-status/capability"
import { getShowSettings } from "./show-settings/capability"
import { getRemoveData } from "./remove-data/capability"
import { getCardButton } from "./card-button/capability"
import { getCardBackSection } from "./card-back-section/capability"
import { getCardBadges } from "./card-badge/capability"

window.TrelloPowerUp.initialize(
  {
    "on-enable": (t: Trello.PowerUp.IFrame) => getOnEnable(t),
    "show-settings": async (t: Trello.PowerUp.IFrame) => await getShowSettings(t),
    'show-authorization': (t: Trello.PowerUp.IFrame) =>
    getShowAuthorization(t),
    'authorization-status': async (t: Trello.PowerUp.IFrame) => {
      return await getAuthorizationStatus(t)
    },
    'remove-data': async (t: Trello.PowerUp.IFrame) => await getRemoveData(t),
    "card-buttons": (t: Trello.PowerUp.IFrame) =>
    getCardButton(t, CAPABILITY_PROPS),
    'card-back-section': async (t: Trello.PowerUp.IFrame) =>
    await getCardBackSection(t, CAPABILITY_PROPS),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'card-badges': async (t: any) => await getCardBadges(t),
    "board-buttons": (t: Trello.PowerUp.IFrame) => [
      {
        icon: CAPABILITY_PROPS.baseUrl + CAPABILITY_PROPS.icon.light,
        text: "Add time",
        callback: (t: Trello.PowerUp.IFrame) => {
          return t.popup({
            title: "Add time",
            url: t.signUrl("./card-button.html"),
            height: 700,
          })
        },
      },
    ]
    
  },
  {
    appKey: import.meta.env.VITE_POWERUP_APP_KEY,
    appName: PUP_DISPLAY_NAME
  }
)
